import { Stack, Typography } from "@mui/material";
import { AddAccountButton } from "Components/BankAccounts/BankAccountList/AddAccountButton";
import { BankAccountListActions } from "Components/BankAccounts/BankAccountList/BankAccountListActions";
import { CurrencyGroupedAccountList } from "Components/BankAccounts/BankAccountList/CurrencyGroupedAccountList";
import { PrimaryAccountDescription } from "Components/BankAccounts/BankAccountList/PrimaryAccountDescription";
import { QuickPaymentSection } from "Components/BankAccounts/BankAccountList/QuickPaymentSection";
import { BlDivider } from "Components/Shared/BlDivider";
import type { BankAccountListItem } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

const PageResources = Resources.Pages.Content.BankAccounts;

type Props = {
  accounts: Array<BankAccountListItem>;
  onSwitchToEditOrderRequested: () => void;
};

export const BankAccountListPageContent = ({
  accounts,
  onSwitchToEditOrderRequested,
}: Props) => {
  const { t } = useResource();

  const hasNoAccount = accounts.length === 0;
  const hasMultipleAccounts = accounts.length > 1;

  if (hasNoAccount) {
    return (
      <>
        <Typography fontSize={16} fontWeight={600}>
          {t(PageResources.NoBankAccounts)}
        </Typography>
        <AddAccountButton />
      </>
    );
  }

  return (
    <Stack>
      <CurrencyGroupedAccountList accounts={accounts} />
      <PrimaryAccountDescription />
      <BlDivider marginTop={6} />
      <QuickPaymentSection
        hasPrimaryAccount={accounts.some(({ isPrimary }) => isPrimary)}
      />
      <BlDivider marginTop={6} />
      <BankAccountListActions
        hasMultipleAccounts={hasMultipleAccounts}
        onSwitchToEditOrderRequested={onSwitchToEditOrderRequested}
      />
    </Stack>
  );
};
